import { PolicyPodetailReq, PolicyPodetailResp } from 'app/bff/models/policy/policyPodetail';
import { PolicyTravelPocancelReq } from 'app/bff/models/policy/policyTravelPocancel';
import {
  DetailActions,
  SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL,
  SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL_DONE,
  SERVICE_QUERT_POLICY_DETAIL__CANCEL_POLICY,
  SERVICE_QUERT_POLICY_PROTECT_DETAIL__FETCH_POLICY_DETAIL
} from './types';

/**
 * @description 取得保單明細 (Action)
 * @param args 請求所需的參數
 * @param isCancel 是否由「取消」按鈕觸發
 */
export const fetchPolicyDetailAction = (args: PolicyPodetailReq, isCancel: boolean): DetailActions => ({
  type: SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL,
  payload: { args, isCancel }
});

export const fetchPolicyProtectDetailAction = (args: PolicyPodetailReq, isCancel: boolean): DetailActions => ({
  type: SERVICE_QUERT_POLICY_PROTECT_DETAIL__FETCH_POLICY_DETAIL,
  payload: { args, isCancel }
});

/**
 * @description 取得保單明細 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const fetchPolicyDetailDoneAction = (response: PolicyPodetailResp['policyTravel']): DetailActions => ({
  type: SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL_DONE,
  payload: { response }
});

export const fetchPolicyProtectDetailDoneAction = (response: PolicyPodetailResp['policyTravel']): DetailActions => ({
  type: SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL_DONE,
  payload: { response }
});

/**
 * @description 取消保單 (Action)
 * @param args 請求所需的參數
 * @param successMessageTitle 取消成功訊息標題
 * @param successMessageContent 取消成功訊息內容
 */
export const cancelPolicyAction = (args: PolicyTravelPocancelReq, successMessageTitle: string, successMessageContent: string): DetailActions => ({
  type: SERVICE_QUERT_POLICY_DETAIL__CANCEL_POLICY,
  payload: { args, successMessageTitle, successMessageContent }
});
